<ng-select
  [items]="timeOptions"
  placeholder="--:-- --"
  bindLabel="label"
  bindValue="value"
  [clearable]="false"
  [formControl]="timePickerControl"
  [searchFn]="searchTimeOptions"
  class="w125"></ng-select>